export default __webpack_public_path__ + "static/media/SWT1990.34I-42363_-25716_0.3e794669.jpg";